(() => {
  function init() {
    document.querySelectorAll('.collection-controls').forEach(form => {
      if (form.dataset.mobileFiltersBound) return;
      form.dataset.mobileFiltersBound = 'true';
      form.querySelector('button[type="submit"]')?.remove();
      form.addEventListener('change', event => {
        if (event.target.matches('select,input') && form.reportValidity()) form.requestSubmit();
      });
      const row = form.querySelector('.filter-row');
      if (!row || !row.querySelector('.filter')) return;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'pb-filter-toggle';
      toggle.textContent = 'Filters +';
      toggle.setAttribute('aria-expanded', 'false');
      row.prepend(toggle);
      form.dataset.filtersExpanded = 'false';
      toggle.addEventListener('click', () => {
        const open = form.dataset.filtersExpanded !== 'true';
        form.dataset.filtersExpanded = String(open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = open ? 'Filters −' : 'Filters +';
      });

    });
    document.querySelectorAll('.pb-mobile-nav-toggle').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      const header = button.closest('.site-header');
      const mobile = matchMedia('(max-width:700px)');
      function close(focus = false) {
        header.removeAttribute('data-mobile-menu-open');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Open navigation menu');
        if (focus) button.focus();
      }
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        if (!open) return close();
        header.setAttribute('data-mobile-menu-open', '');
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-label', 'Close navigation menu');
      });
      document.addEventListener('click', event => {
        if (!header.isConnected) return;
        if (!header.contains(event.target) || event.target.closest('.quick-nav a,.mega-menu > summary')) close();
      });
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') close(true);
      });
      mobile.addEventListener('change', () => { if (!mobile.matches) close(); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
  // Tidio renders into an open shadow root, so keep this rule inside that root.
  // The conversation and launcher stay available; only the mobile teaser hides.
  let chatAttempts = 0;
  function compactChat() {
    const root = document.getElementById('tidio-chat')?.shadowRoot;
    if (root) {
      if (!root.querySelector('[data-pb-mobile-chat]')) {
        const style = document.createElement('style');
        style.dataset.pbMobileChat = '';
        style.textContent = '@media(max-width:700px){[data-testid="widgetLabel"]{display:none!important}}';
        root.append(style);
      }
      return;
    }
    if (++chatAttempts < 60) setTimeout(compactChat, 1000);
  }
  compactChat();
  document.addEventListener('tidioChat-ready', compactChat);
})();
